import { useTranslation } from 'react-i18next'

interface Option {
  value: string
  label: string
}

interface FilterMultiCheckboxProps {
  options: Option[]
  value: string[]
  onChange: (value: string[]) => void
}

/** Multi-select checkboxes for string[] filter values (e.g. housing types). */
const FilterMultiCheckbox = ({ options, value, onChange }: FilterMultiCheckboxProps) => {
  const { t } = useTranslation()
  const selected = Array.isArray(value) ? value : []

  const handleToggle = (optionValue: string) => {
    if (selected.includes(optionValue)) {
      onChange(selected.filter(item => item !== optionValue))
      return
    }
    onChange([...selected, optionValue])
  }

  return (
    <div className="flex flex-col gap-2">
      {options.map(opt => {
        const checked = selected.includes(opt.value)
        return (
          <label
            key={opt.value}
            className="flex min-h-[44px] items-center gap-2 cursor-pointer text-sm text-gray-800 lg:min-h-0"
          >
            <input
              type="checkbox"
              checked={checked}
              onChange={() => handleToggle(opt.value)}
              className="h-4 w-4 rounded border-gray-300 text-imovPrimary focus:ring-imovPrimary"
            />
            <span>{opt.label.includes('.') ? t(opt.label) : opt.label}</span>
          </label>
        )
      })}
    </div>
  )
}

export default FilterMultiCheckbox
